var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocAssistant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7134 7.12811L18.4668 7.69379C18.2864 8.10792 17.7136 8.10792 17.5331 7.69379L17.2866 7.12811C16.8471 6.11947 16.0555 5.31641 15.0677 4.87708L14.308 4.53922C13.8973 4.35653 13.8973 3.75881 14.308 3.57612L15.0252 3.25714C16.0384 2.80651 16.8442 1.97373 17.2761 0.930831L17.5293 0.319531C17.7058 -0.10651 18.2942 -0.10651 18.4706 0.319531L18.7238 0.930831C19.1558 1.97373 19.9616 2.80651 20.9748 3.25714L21.6919 3.57612C22.1027 3.75881 22.1027 4.35653 21.6919 4.53922L20.9323 4.87708C19.9445 5.31641 19.1529 6.11947 18.7134 7.12811ZM18 10C18.6695 10 19.3134 9.8903 19.9147 9.688C19.971 10.1174 20 10.5553 20 11C20 16.5228 15.5228 21 10 21C8.2975 21 6.6944 20.5746 5.29117 19.8242L0 21L1.17581 15.7088C0.42544 14.3056 0 12.7025 0 11C0 5.47715 4.47715 1 10 1C10.9056 1 11.7831 1.12039 12.6174 1.34603C12.2221 2.14617 12 3.04715 12 4C12 7.31371 14.6863 10 18 10ZM5 11C5 13.7614 7.23858 16 10 16C12.7614 16 15 13.7614 15 11H13C13 12.6569 11.6569 14 10 14C8.3431 14 7 12.6569 7 11H5Z",
    fill: "#0076FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocAssistant);
export default __webpack_public_path__ + "static/media/docAssistant.ae7186a42bac6e29654c59822d501bc9.svg";
export { ForwardRef as ReactComponent };